/* eslint-disable */

export const getToken = () => {
  cordova.plugins.firebase.messaging.getToken().then(function (token) {});
};

export const getTokenPromise = async () => {
  return cordova.plugins.firebase.messaging.getToken();
};

export const getRefreshToken = () => {
  cordova.plugins.firebase.messaging.onTokenRefresh(function () {});
};

export const requestPermission = () => {
  cordova.plugins.firebase.messaging.requestPermission({ forceShow: true }).then(function () {
    console.log('Push messaging is allowed');
  });
};

export const registerOnMessage = (callback) => {
  if (typeof callback === 'function') {
    cordova.plugins.firebase.messaging.onMessage(function (payload) {
      callback(payload, 'FOREGROUND');
    });

    cordova.plugins.firebase.messaging.onBackgroundMessage(function (payload) {
      callback(payload, 'BACKGROUND');
    });
  }
};

export const registerOnToken = (callback) => {
  if (typeof callback === 'function') {
    cordova.plugins.firebase.messaging.getToken().then(function (token) {
      callback(token);
    });
  }
};

export const getOnToken = () => {
  return cordova.plugins.firebase.messaging.getToken();
};

export const subscribeToTopic = () => {
  cordova.plugins.firebase.messaging.subscribe('geral');
  if (device.platform == 'IOS') {
    cordova.plugins.firebase.messaging.subscribe('ios');
  } else if (device.platform === 'Android') {
    cordova.plugins.firebase.messaging.subscribe('android');
  }
};

export const unsubscribeToTopic = () => {
  cordova.plugins.firebase.messaging.unsubscribe('geral');
  if (device.platform == 'IOS') {
    cordova.plugins.firebase.messaging.unsubscribe('ios');
  } else if (device.platform === 'Android') {
    cordova.plugins.firebase.messaging.unsubscribe('android');
  }
};

export const reviewDialog = () => {
  // request dialog and provide fallback
  cordova.plugins.AppReview.requestReview().catch(function () {
    return cordova.plugins.AppReview.openStoreScreen();
  });

}